import { render } from "./ShowerRecords.vue?vue&type=template&id=5b6761ba&scoped=true"
import script from "./ShowerRecords.vue?vue&type=script&lang=js"
export * from "./ShowerRecords.vue?vue&type=script&lang=js"

import "./ShowerRecords.vue?vue&type=style&index=0&id=5b6761ba&scoped=true&lang=scss"

import exportComponent from "/home/brant/git/HeySensCloudWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6761ba"]])

export default __exports__